import axios from 'axios';
var url_api = process.env.REACT_APP_CNPL_PURCHASE_BASE_API_PREPROD;

export const orderService = (url, sessionId) => {
  return axios.post(url_api + `order/${url}`, { session_id:sessionId });
};

export const deleteOrderService = (sessionId) => {
  return axios.post(url_api + `order/cancel`, { session_id:sessionId });
};

export const seatsService = (url, data) => {
  return axios.post(url_api + url, data).then(data => data.data);
};

export const ticketsService = (cinemaVistaId, showtimeVistaId, reload, cinema_type, screen, sessionId, tokenG) => {
  return axios.post(url_api + 'tickets', { cinema_vista_id: cinemaVistaId, showtime_vista_id: showtimeVistaId, reload, app_dynamics: { cinema_type, screen }, session_id: sessionId, token: tokenG }, { headers: { 'sessionId': sessionId } });
};

export const reservationService = (data, sessionId, tokenR) => {
  return axios.post(url_api + 'purchase/unpaid_booking', {
    session_id: sessionId,
    bill_to: data,
    token_google: tokenR
  });
};
 
export const bankCardService = (data, sessionId, fingerprintId, cardType, tokenR) => {
  let month = data.card_date.split('/')[0];
  let year = data.card_date.split('/')[1];
  return axios.post(url_api + 'purchase/bank_card', {
    session_id: sessionId,
    bill_to: data,
    card: {
      cvc: data.card_cvv,
      expiry_month: month,
      expiry_year: year,
      number: data.card_number,
      type: cardType
    },
    loyalty_card: data.loyalty,
    fingerprint_id: fingerprintId,
    token_google: tokenR
  });
};

export const spreedlyService = (data, sessionId, fingerprintId, paymentMethod, tokenR, first_six_digits) => {
  return axios.post(url_api + 'purchase/spreedly',
    {
      bill_to: data,
      payment_method: paymentMethod,
      fingerprint_id: fingerprintId,
      token_google: tokenR,
      session_id: sessionId,
      first_six_digits
    });
};

export const cineCashBalance = (accessToken) => {
  return axios.get(url_api + 'purchase/cinecash/balance', {
    params: { accessToken }
  });
};

export const cineCashPaymentService = (data, sessionId, accessToken, cinemaName, movieName, loyaltyNumber, tokenR) => {
  return axios.post(url_api + 'purchase/cinecash',
    {
      session_id: sessionId,
      access_token: accessToken,
      cinema_name: cinemaName,
      movie_name: movieName,
      bill_to: data,
      loyalty_card: loyaltyNumber,
      token_google: tokenR
    });
};

export const movieYelmoPaymentService = (data, sessionId, pin, loyaltyNumber, tokenR) => {
  return axios.post(url_api + 'purchase/club_cinepolis',
    {
      session_id: sessionId,
      bill_to: data,
      pin,
      card_number: loyaltyNumber,
      token_google: tokenR
    });
};

export const paypalOrderService = (sessionId, tickets, amount, cinemaVistaId, tokenR, concessions, bookingFee) => {  
  try {
    var items = tickets.map((ticket) => {
      return {
        price: ticket.price,
        product: ticket.type,
        description: ticket.type,
        quantity: ticket.quantity
      };
    });
    if (typeof concessions.concessions !== 'undefined' && concessions.concessions !== null) {
      concessions.concessions.map((concession) => {
        items.push({
          price: parseInt(concessions.concessions_total / concessions.concessions.length),
          product: concession.name,
          description: concession.name,
          quantity: concession.quantity
        });
      });
    }
    if (bookingFee > 0) {
      items.push({
        price: bookingFee,
        product: 'CARGO POR SERVICIO',
        description: 'CARGO POR SERVICIO',
        quantity: 1
      });
    }
    return axios.post(url_api + 'purchase/paypal/order',
      {
        session_id: sessionId,
        cinema_vista_id: cinemaVistaId,
        amount,
        items,
        token_google: tokenR
      });
  } catch (e) {
    console.log(e);
  }
  
};

export const getBizumService = (countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, billTo, tokenR, clubCarrefour = "") => {
  return axios.post(url_api + "purchase/bizum_pay_data/",{
    country_code: countryCode,
    session_id: sessionId,
    showtime_vista_id: showtimeId,
    cinema_vista_id: cinemaId,
    loyalty_card: loyaltyCard,
    order_type: paymentType,
    bill_to: billTo,
    token_google: tokenR,
    club_carrefour: clubCarrefour
  });
};

export const getRedsysService = (countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, billTo, tokenR, clubCarrefour = "") => {
  return axios.post(url_api + "purchase/redsys_pay_data/",
    {
      country_code: countryCode,
      session_id: sessionId,
      showtime_vista_id: showtimeId,
      cinema_vista_id: cinemaId,
      loyalty_card: loyaltyCard,
      order_type: paymentType,
      bill_to: billTo,
      token_google: tokenR,
      club_carrefour: clubCarrefour
    });
};

export const bizumServiceValidate = (countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, merchantOrderId, billTo) => {
  return axios.post(url_api + "purchase/bizum_validate_data",
    {
      country_code: countryCode,
      session_id: sessionId,
      showtime_vista_id: showtimeId,
      cinema_vista_id: cinemaId,
      loyalty_card: loyaltyCard,
      order_type: paymentType,
      merchant_order_id: merchantOrderId,
      bill_to: billTo,
    });
};

export const redsysServiceValidate = (countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, merchantOrderId, billTo) => {
  return axios.post(url_api + "purchase/redsys_validate_data",
    {
      country_code: countryCode,
      session_id: sessionId,
      showtime_vista_id: showtimeId,
      cinema_vista_id: cinemaId,
      loyalty_card: loyaltyCard,
      order_type: paymentType,
      merchant_order_id: merchantOrderId,
      bill_to: billTo,
    });
};

export const visaCheckOutDecryptService = (data, wrappedKey) => {
  return axios.post(url_api + 'purchase/visa_checkout/decrypt',
    {
      data,
      wrapped_key: wrappedKey
    });
};

export const visaCheckoutService = (data, wrappedKey, billTo, callId, card, cinema, fingerPrintId, loyaltyCard, movie, sessionId) => {
  return axios.post(url_api + 'purchase/visa_checkout',
    {
      data,
      wrapped_key: wrappedKey,
      session_id: sessionId,
      cinema,
      movie,
      card,
      call_id: callId,
      finger_print_id: fingerPrintId,
      bill_to: billTo,
      loyalty_card: loyaltyCard
    });
};

export const annualPassService = (data, sessionId, tokenR) => {
  return axios.post(url_api + 'purchase/annual_pass', {
    session_id: sessionId,
    bill_to: data,
    token_google: tokenR
  });
};

export const priceZeroService = (data, sessionId, tokenR) => {
  return axios.post(url_api + 'purchase/promotions', {
    session_id: sessionId,
    bill_to: data,
    token_google: tokenR
  });
};

export const showtimeService = (cinemaVistaId, showtimeVistaId, tokenR) => {
  return axios.post(url_api + 'schedule', { cinema_vista_id: cinemaVistaId, showtime_vista_id: showtimeVistaId,  token: tokenR });
};

export const loginService = (userName, password) => {
  return axios.post(url_api + 'login/validate', { userName, password });
};

export const cardsService = (showtimeVistaId, cinemaVistaId, folio, app_dynamics, session_id, tokenR) => {
  return axios.post(url_api + 'tickets/benefit/validate', {
    showtime_vista_id: showtimeVistaId,
    cinema_vista_id: cinemaVistaId,
    folio,
    app_dynamics,
    session_id,
    token: tokenR,
  }).then(data => data.data);
};

export const benefitInvalidateService = (showtimeVistaId, cinemaVistaId, folio, app_dynamics, session_id, tokenR) => {
  return axios.post(url_api + 'tickets/benefit/invalidate', {
    showtime_vista_id: showtimeVistaId,
    cinema_vista_id: cinemaVistaId,
    folio,
    app_dynamics,
    session_id,
    token: tokenR,
  }).then(data => data.data);
};

export const getCinemas = (cityId) => {
  return axios.get(url_api + 'location/cinemas', { params: { cityId } });
};

export const getBenefitsService = () => {
  return axios.get(url_api + 'tickets/benefits');
};

export const getFooterService = () => {
  return axios.get(url_api + 'footer');
};

export const getShowtimeInfoService = (cinemaVistaId, showtimeVistaId) => {
  return axios.get(url_api + 'showtime',
    {
      params: {
        cinemaVistaId,
        showtimeVistaId
      }
    });
};

export const getSettingsService = () => {
  return axios.get(url_api + 'settings');
};

export const recoverPinService = (card) => {
  return axios.post(url_api + 'loyalty/recover_pin',
    {
      card_number: card
    });
};

export const getAppleWalletService = (obj) => {
  return axios.post(url_api + 'service/applewallet', obj).then(data => data.data);
};

export const getCities = () => {
  return axios.get(url_api + "location/cities");
};

